import { render, staticRenderFns } from "./StockListRevisions.vue?vue&type=template&id=43b53763"
import script from "./StockListRevisions.vue?vue&type=script&lang=js"
export * from "./StockListRevisions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports